import styles from './UIUXDesignLp2.module.scss'
import LpIntroduction from './LpIntroduction/LpIntroduction'
import OurAdvantage from './OurAdvantage/OurAdvantage'
import ContactButtonArea from './ContactButtonArea/ContactButtonArea'
import Process from './Process/Process'
import OurWorks from './OurWorks/OurWorks'
import CaseStudy from './CaseStudy/CaseStudy'
import PictureBox from './PictureBox/PictureBox'
import ProjectFlow from './ProjectFlow/ProjectFlow'
import ContactForm from './ContactForm/ContactForm'
import FAQ from './FAQ/FAQ'

const UIUXDesignLp2: React.VFC = () => {
  return (
    <>
      <article className={styles.LPPage}>
        <LpIntroduction />
        <OurAdvantage />
        <ContactButtonArea />
        {/* <Process /> */}
        <OurWorks />
        <CaseStudy />
        <PictureBox />
        <ContactButtonArea />
        <FAQ />
        <ProjectFlow />
        <ContactForm />
      </article>
    </>
  )
}

export default UIUXDesignLp2
